import VerifyBtn from '@/components/VerifyBtn/VerifyBtn';
// import Geetest from '../../../components/geetest/Geetest';
import { mapGetters } from 'vuex';
import { accountApi } from '@/api/accountApi';
import { getterTypes } from '@/store/getter-types';

export default {
  name: 'ForgetPwd',
  components: {
    VerifyBtn
    // Geetest,
  },
  data() {
    return {
      curTab: 'tab2',
      // 通过手机找回密码数据
      form_phone: {
        countryCode: '', // 如果是通过手机找回则需要，否则可以不传递
        ga_code: '', // 后端未校验谷歌验证码，可以不填
        mobile: '', // 如果是通过手机找回则需要，否则可以不传递
        password: '',
        validateCode: '',
        repwd: ''
      },
      geetest_phone: {},
      geetest_phone_error: false,
      form_phone_loading: false,
      // 通过邮箱找回密码数据
      form_email: {
        email: '',
        ga_code: '', // 后端未校验谷歌验证码，可以不填
        password: '',
        validateCode: '',
        repwd: ''
      },
      geetest_email: {},
      form_email_loading: false,
      geetest_email_error: false,
      showPassword: false,
      showConfirmedPwd: false
    };
  },
  computed: {
    ...mapGetters([getterTypes.Getter_Lang])
  },
  mounted() {},
  methods: {
    // 使用手机找回密码，获取验证码条件
    getVerifyCodeByPhoneCondition() {
      let $form_phone = this.$v.form_phone;
      $form_phone.countryCode.$touch();
      if ($form_phone.countryCode.$error) {
        return false;
      }
      $form_phone.mobile.$touch();
      if ($form_phone.mobile.$error) {
        return false;
      }
      return true;
    },
    // 使用邮箱找回密码，获取验证码条件
    async getVerifyCodeByEmailCondition() {
      let valid = await this.$refs.email.validate();
      if (!valid) {
        return false;
      }
      return true;
    },
    // 使用手机找回
    findPwdByPhone() {
      let $form_phone = this.$v.form_phone;
      $form_phone.$touch();
      if ($form_phone.$error) {
        return;
      }
      let geetestPhone = this.geetest_phone;
      if (this.$refs.form_phone_geetest.showGeetest) {
        if (
          !this.geetest_phone.geetest_challenge &&
          !this.geetest_phone.geetest_validate &&
          !this.geetest_phone.geetest_seccode
        ) {
          this.geetest_phone_error = true;
          return;
        } else {
          this.geetest_phone_error = false;
        }
      }
      let data = {
        ...this.form_phone
      };
      delete data.repwd;
      this._requestResetPwd(data, this.geetest_phone, 1);
    },
    // 使用邮箱找回
    findPwdByEmail() {
      // let geetestEmail = this.geetest_email;
      // if (this.$refs.form_email_geetest.showGeetest) {
      //   if (!geetestEmail.geetest_challenge && !geetestEmail.geetest_validate && !geetestEmail.geetest_seccode) {
      //     this.geetest_email_error = true;
      //     return;
      //   }
      // }
      let data = {
        username: this.form_email.email,
        otp: this.form_email.validateCode.toString(),
        password: this.form_email.password
      };
      this._requestResetPwd(data, null, 2);
    },
    // 真正的接口请求
    async _requestResetPwd(data, geetestData, type) {
      type === 1 ? (this.form_phone_loading = true) : (this.form_email_loading = true);
      accountApi
        .resetPwd(data)
        .then(() => {
          this.successNotify(this.$t('success.resetPwd'));
          let timer = setTimeout(() => {
            this.$router.replace({ name: 'login' });
            clearTimeout(timer);
          }, 1000);
        })
        .catch(() => {
          if (type === 1) {
            this.form_phone_loading = false;
            this.form_phone_error = false;
            this.geetest_phone = {};
            // this.$refs.form_phone_geetest.init();
          } else {
            this.form_email_loading = false;
            this.form_email_error = false;
            this.geetest_email = {};
            // this.$refs.form_email_geetest.init();
          }
        });
    },
    redirectToHome() {
      this.$router.push({ name: 'home' });
    },
    isNumeric(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    }
  }
  // validations,
};
